import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, forwardRef, OnInit, ViewChild, Input } from '@angular/core';

import { InputAtomSharedComponent } from '../../atoms/input/input.component';

export const EXPIRY_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref no-use-before-declare
    useExisting: forwardRef(() => ExpirySharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-expiry',
    templateUrl: './expiry.component.html',
    styleUrls: ['./expiry.component.scss'],
    providers: [
        EXPIRY_CUSTOM_INPUT_ACCESSOR
    ]
})

export class ExpirySharedComponent extends InputAtomSharedComponent implements OnInit {
    @ViewChild(InputAtomSharedComponent) inputComponent: InputAtomSharedComponent;

    // tslint:disable-next-line: no-input-rename
    @Input('value') _value = '';
    @Input() inputStyle = 'primary';

    focused = false;

    formatValue(value: string): string {
        if (value) {
            // strip white spaces and non numbers
            // tslint:disable-next-line: radix
            const number = value.replace(/\s|\/|\D+/g, '');
            if (number) {
                // limit to 4 characters, split every 2 and add slash in between
                const formatted = number.substr(0, 4).match(/.{1,2}/g).join('/');

                // append slash after entering 2 characters
                return value.length === 2 ? formatted + '/' : formatted;
            } else {
                return '';
            }
        }
    }

    updateValue(event: KeyboardEvent): void {
        const target = event.target as HTMLInputElement;

        const value = this.formatValue(target.value);
        if (value !== undefined) {
            target.value = value;
            this.value = value;
        }
    }

    ngOnInit(): void {
        this.inputComponent.updateValue = this.updateValue.bind(this);
    }
}
